import React from "react";

// Page title block for the Driver Breakdown report. Values map 1:1 to the Figma
// design (frame exported at 1.8537x, so each Figma px is divided back to real
// px — e.g. title 61.443px -> 33px). The driver's name lives in the BioCard
// below, so the header title is static per the design.
//
// @param {string} loggedInAs - Name of the signed-in admin viewing the report.
// @param {{from: string, to: string}} range - The week range shown in the chip.
const PageHeader = ({ loggedInAs, range }) => (
  <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center" style={{ gap: 12 }}>
    <div>
      <h1 className="font-medium tracking-tight text-gray-700" style={{ fontSize: 33, lineHeight: 1.15 }}>
        Driver Breakdown - Weekly Report
      </h1>
      <p className="text-gray-500" style={{ fontSize: 16, marginTop: 4 }}>
        Logged in as {loggedInAs || "Admin"}
      </p>
    </div>
    <div className="bg-white text-gray-700" style={{ padding: "9px 16px", fontSize: 13, borderRadius: 5, border: "1px solid rgba(110, 108, 113, 0.3)" }}>
      <span className="uppercase text-gray-500" style={{ letterSpacing: "0.05em", fontSize: 11, marginRight: 8 }}>
        Week
      </span>
      {range.from || "—"} <span className="text-gray-500" style={{ margin: "0 4px" }}>→</span> {range.to || "—"}
    </div>
  </header>
);

export default PageHeader;
